// Google Maps configuration
// API key for in-app maps, navigation, and directions.
//
// SECURITY NOTE: This key is consumed in the browser, so it cannot be truly
// hidden. Protect it in Google Cloud Console with:
//   1. Application restriction: HTTP referrers (e.g. https://tenantscore.co.ke/*)
//   2. API restriction: enable only Maps JavaScript API + Directions API
//   3. Set quota limits to detect abuse.
//
// In CI/CD, set REACT_APP_GOOGLE_MAPS_API_KEY as a build-time env var
// (add it to .env.production or inject it in the deploy workflow).
export const GOOGLE_MAPS_API_KEY =
  process.env.REACT_APP_GOOGLE_MAPS_API_KEY ||
  'AIzaSyC-e7cSt_4gOVGWrnQ8h2gIh9QFVBNr64I';

// Default center for maps when no coords are available (Nairobi, Kenya).
export const DEFAULT_MAP_CENTER = { lat: -1.2921, lng: 36.8219 };
